<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <h3 class="my-5 mx-3">Preferences</h3>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-layout row>
          <v-flex xs11 sm6 offset-sm3>
            <v-row cols="12">
              <v-checkbox class="mx-8" v-model="emailPref" :label="emailPref ? 'Stop sending emails' : 'Continue sending emails'" />
            </v-row>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs11 sm6 offset-sm3>
            <v-row cols="12">
              <v-checkbox class="mx-8" v-model="smsPref" :label="smsPref ? 'Stop sending sms' : 'Continue sending sms'" />
            </v-row>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs11 sm6 offset-sm3>
             <v-col>
                <v-btn
                  color="success"
                  class="mx-2"
                  @click="updatePrefs"
                  >Update Preference</v-btn
                >
             </v-col>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- snackBar Start -->
    <v-snackbar color="success" v-model="snackbarVal" :timeout="2000" top>
      Preference has been updated
      <template v-slot:action="{ attrs }">
        <v-btn color="success" text v-bind="attrs" @click="snackbar = false"
          >Ok</v-btn
        >
      </template>
    </v-snackbar>
    <!-- snackBar End -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      emailPref: true,
      smsPref: true,
      snackbarVal: false
    };
  },
  methods: {
    updatePrefs() {
      // updates user prefs
      // this.snackbarVal = true
    },
  }
};
</script>
